export default {
    topChatUserInfo: state => state.topChatUserInfo,
    token:state => state.token,  
    chatType:state => state.chatType, 
    appTemplate:state => state.appTemplate, 
    templateAppList:state => state.templateAppList,
    chatConfig:state => state.chatConfig,
    myTemplateList:state => state.myTemplateList,
    chatTemplate:state => state.chatTemplate,  
    productsList:state => state.productsList,
    isLogin :state => state.isLogin,
    demoQuestionsList:state => state.demoQuestionsList,
}